import GradualRegistrationButton from './gradual-registration-button';

const PreFooter = () => (
  <section className="border-t border-neutral-800">
    <div className="pt-20 pb-28 lg:py-[136px] container relative text-center">
      <p className="uppercase tracking-[4px] text-transform-x-gradient">
        Detailed agenda of keynotes, fireside chats, and expert panels coming soon.
      </p>
      <div className="mt-10" />
      <GradualRegistrationButton />
    </div>
  </section>
);

export default PreFooter;
